var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { jwtDecode } from 'jwt-decode';
import useConfigStore from '../stores/configStore';
import api, { instance } from '../api';
import useCustomerStore from '../stores/customerStore';
import useErrorStore from '../stores/errorStore';
import { generateRefreshData } from '../utils/generateRefreshData';
import axios from 'axios';
var AuthState;
(function (AuthState) {
    AuthState["NOT_INITIALIZED"] = "NOT_INITIALIZED";
    AuthState["PENDING"] = "PENDING";
    AuthState["COMPLETE"] = "COMPLETE";
    AuthState["EXPIRED"] = "EXPIRED";
})(AuthState || (AuthState = {}));
var useToken = function () {
    var refreshTokenRef = useRef();
    var hmacData = useRef(null);
    var setHMACData = function (newData) {
        hmacData.current = newData;
    };
    var getHMACData = function () {
        return hmacData.current;
    };
    var pushTokenLog = function (log) {
        var windowAny = window;
        if (windowAny.tokenLogs) {
            windowAny.tokenLogs.push(log);
        }
        else {
            windowAny.tokenLogs = [log];
        }
    };
    var _a = useConfigStore(), keys = _a.keys, setConfigV2 = _a.setConfigV2;
    var _b = useCustomerStore(), extCustomerID = _b.extCustomerID, extCustomerEmail = _b.extCustomerEmail, extCustomerName = _b.extCustomerName;
    var _c = useState(AuthState.NOT_INITIALIZED), authState = _c[0], setAuthState = _c[1];
    var setError = useErrorStore().setError;
    var createCustomer = useMutation(api.customer.create);
    var refreshTokenWithSigning = useMutation(api.auth.refreshTokenWithSigning);
    var getSigningKey = useMutation(api.auth.getSigningKey);
    var refreshTokenHandler = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var extCustomerID_1, platformId, _a, keyId, hmacSecret, refreshData, response, accessToken, decoded, tokenType, _b, e_1, rawErrors, errorMessage, error_1, errorMessage;
        var _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _k.trys.push([0, 10, , 11]);
                    extCustomerID_1 = payload.extCustomerID, platformId = payload.platformId;
                    _a = getHMACData(), keyId = _a.keyId, hmacSecret = _a.hmacSecret;
                    return [4 /*yield*/, generateRefreshData(platformId, extCustomerID_1, keyId, hmacSecret)];
                case 1:
                    refreshData = _k.sent();
                    return [4 /*yield*/, refreshTokenWithSigning.mutateAsync(refreshData)];
                case 2:
                    response = _k.sent();
                    accessToken = response.data.accessToken;
                    if (!accessToken) {
                        throw new Error();
                    }
                    pushTokenLog({ 'NEW ACCESS TOKEN': { accessToken: accessToken } });
                    instance.defaults.headers.common['authorization'] = accessToken;
                    setConfigV2({
                        keys: {
                            token: accessToken,
                            initToken: null,
                            hmacData: { keyId: keyId, hmacSecret: hmacSecret }
                        }
                    });
                    decoded = jwtDecode(accessToken);
                    tokenType = decoded.saasPlatformId ? 'platform' : 'customer';
                    _b = tokenType;
                    switch (_b) {
                        case 'platform': return [3 /*break*/, 3];
                        case 'customer': return [3 /*break*/, 8];
                    }
                    return [3 /*break*/, 9];
                case 3:
                    _k.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, createCustomer.mutateAsync({
                            customerName: extCustomerName,
                            customerEmail: extCustomerEmail,
                            externalID: extCustomerID_1,
                            platformId: keys.platformId
                        })];
                case 4:
                    _k.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _k.sent();
                    rawErrors = 'Something went wrong';
                    if (axios.isAxiosError(e_1)) {
                        rawErrors =
                            ((_d = (_c = e_1.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
                                ((_f = (_e = e_1.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.error) ||
                                rawErrors;
                    }
                    else if (e_1 instanceof Error) {
                        rawErrors = e_1.message;
                    }
                    errorMessage = Array.isArray(rawErrors)
                        ? rawErrors
                            .map(function (err) {
                            var match = err.match(/field "(.+?)"/);
                            if (match === null || match === void 0 ? void 0 : match[1]) {
                                var field = match[1]
                                    .replace(/([A-Z])/g, ' $1')
                                    .replace(/^./, function (s) { return s.toUpperCase(); });
                                return "".concat(field, " is required");
                            }
                            return err;
                        })
                            .join(', ')
                        : rawErrors;
                    setError({
                        error: errorMessage
                    });
                    return [2 /*return*/];
                case 6: return [4 /*yield*/, refreshTokenHandler(payload)];
                case 7: return [2 /*return*/, _k.sent()];
                case 8: return [2 /*return*/, accessToken];
                case 9: return [3 /*break*/, 11];
                case 10:
                    error_1 = _k.sent();
                    pushTokenLog({ 'ACCESS TOKEN ERROR': __assign({}, error_1) });
                    setAuthState(AuthState.EXPIRED);
                    errorMessage = ((_h = (_g = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.message) || (error_1 === null || error_1 === void 0 ? void 0 : error_1.message);
                    if (((_j = error_1 === null || error_1 === void 0 ? void 0 : error_1.message) === null || _j === void 0 ? void 0 : _j.includes('401')) ||
                        (error_1 === null || error_1 === void 0 ? void 0 : error_1.code) == '401' ||
                        JSON.stringify(error_1) == JSON.stringify({})) {
                        setError({
                            error: 'Your session has expired due to inactivity. Please refresh and try again.'
                        });
                    }
                    else if (keys.widgetType === 'broker' &&
                        errorMessage == 'Quote has already been purchased') {
                        setError({
                            error: 'This horse combination is already part of another purchased policy and cannot be quoted again.'
                        });
                    }
                    else {
                        setError({
                            error: 'Oops! Something went wrong. Please refresh and try again.'
                        });
                    }
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var setupRefreshInterval = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var accessToken, decoded, expireTime, beforeExpire, secondsToWait;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, refreshTokenHandler(payload)];
                case 1:
                    accessToken = _a.sent();
                    if (refreshTokenRef.current) {
                        clearTimeout(refreshTokenRef.current);
                    }
                    decoded = jwtDecode(accessToken);
                    expireTime = decoded.exp;
                    beforeExpire = expireTime - 20;
                    secondsToWait = beforeExpire - Math.floor(new Date().getTime() / 1000);
                    refreshTokenRef.current = setTimeout(function () {
                        setupRefreshInterval(payload);
                    }, secondsToWait * 1000);
                    return [2 /*return*/, accessToken];
            }
        });
    }); };
    var initialize = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1, _a, keyId, hmacSecret;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setAuthState(AuthState.PENDING);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getSigningKey.mutateAsync({ token: keys.initToken })];
                case 2:
                    response = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    setError({ error: "Request failed. Please review your configuration and try again." });
                    return [2 /*return*/];
                case 4:
                    _a = response.data, keyId = _a.keyId, hmacSecret = _a.hmacSecret;
                    pushTokenLog({ 'SETTING HAMC': { keyId: keyId, hmacSecret: hmacSecret } });
                    setHMACData({ keyId: keyId, hmacSecret: hmacSecret });
                    setConfigV2({
                        keys: {
                            initToken: null
                        }
                    });
                    return [4 /*yield*/, setupRefreshInterval({
                            extCustomerID: extCustomerID,
                            platformId: keys.platformId
                        })];
                case 5:
                    _b.sent();
                    setAuthState(AuthState.COMPLETE);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if ((keys === null || keys === void 0 ? void 0 : keys.initToken) &&
            authState === AuthState.NOT_INITIALIZED &&
            extCustomerID) {
            pushTokenLog({ INITIALIZING: { initToken: keys === null || keys === void 0 ? void 0 : keys.initToken } });
            initialize();
        }
    }, [keys === null || keys === void 0 ? void 0 : keys.initToken, authState, extCustomerID]);
    return {
        tokenLoading: Boolean(extCustomerID) && authState !== AuthState.COMPLETE,
        refreshToken: function () {
            var _a = keys.hmacData, keyId = _a.keyId, hmacSecret = _a.hmacSecret;
            return setupRefreshInterval({
                keyId: keyId,
                hmacSecret: hmacSecret,
                extCustomerID: extCustomerID,
                platformId: keys.platformId
            });
        },
        pushTokenLog: pushTokenLog
    };
};
export default useToken;
